export default "__VITE_ASSET__BpjUbQ$M__"